const items = [
  "Starlit LED",
  "Seamless All-White Dancefloor",
  "Mirror Gold",
  "Mirror Silver",
  "Custom Monograms",
  "Custom Printed Wraps",
  "Stage Wraps",
  "Overnight Installs",
  "White & Black Starlit",
  "Infinity! Mirror LED Floors",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div data-testid="marquee-ribbon" className="relative py-10 border-y border-ink/10 overflow-hidden bg-ivory">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic font-light text-2xl sm:text-3xl text-ink/45 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-gold text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
